@if(specialistSignUpDetails(); as details) {
<div class="specialist-sign-up-details-part bg-light rounded shadow-sm h-100">
	<div class="p-3">
		<div class="d-flex flex-column gap-2">
			<div class="d-flex">
				<div class="fw-bold me-2">Specialist:</div>
				<span role="button" class="text-decoration-underline"
					(click)="openPersonDialog(details.person.id)">
					{{details.person.fullName}}
				</span>
			</div>
		</div>
		<div class="d-flex">
			<div class="fw-bold me-2">Trimester:</div>
			<div>{{details.trimesterName}}</div>
		</div>
		<div class="d-flex">
			<div class="fw-bold me-2">Sign-Up Created Date:</div>
			<div>{{details.formattedCreatedUTC}}</div>
		</div>
		<div class="d-flex mt-2">
			<div class="fw-bold me-2">Events available:</div>
			<div>{{details.topics.length}}</div>
		</div>
		<div class="d-flex mt-2">
			<div class="fw-bold me-2">Note:</div>
			<div class="pre-line">{{details.note||'N/A'}}</div>
		</div>
	</div>
</div>
}